module.exports = __webpack_public_path__ + "img/Capitals Bingo 3.c12e6287.jpeg";